// FAQ data
export const faqItems = [
  {
    emoji: "🤔",
    question: "Qu'est-ce que le Personal Training ?",
    questionEn: "What is Personal Training?",
    answerPoints: [
      "✓ Coach dédié 100% pour vous",
      "✓ Studio privé 150m²",
      "✓ Programme sur-mesure",
      "✓ Méthode personnalisée"
    ],
    answerPointsEn: [
      "✓ Dedicated coach 100% for you",
      "✓ Private 150m² studio",
      "✓ Custom program",
      "✓ Personalized method"
    ]
  },
  {
    emoji: "🚀",
    question: "Plus efficace qu'une salle classique ?",
    questionEn: "More effective than a regular gym?",
    answerPoints: [
      "✓ 3-5x plus efficace (études prouvées)",
      "✓ Programme = VOS objectifs",
      "✓ Technique parfaite",
      "✓ Progression optimisée"
    ],
    answerPointsEn: [
      "✓ 3-5x more effective (proven studies)",
      "✓ Program = YOUR goals",
      "✓ Perfect technique",
      "✓ Optimized progression"
    ]
  },
  {
    emoji: "⏱️",
    question: "Combien de séances/semaine ?",
    questionEn: "How many sessions/week?",
    answerPoints: [
      "✓ Optimal : 2-3x/semaine",
      "✓ Minimum : 1x/semaine",
      "✓ Planning personnalisé",
      "✓ Consultation gratuite 🎁"
    ],
    answerPointsEn: [
      "✓ Optimal: 2-3x/week",
      "✓ Minimum: 1x/week",
      "✓ Personalized schedule",
      "✓ Free consultation 🎁"
    ]
  },
  {
    emoji: "🎯",
    question: "Quels objectifs possibles ?",
    questionEn: "What goals are possible?",
    answerPoints: [
      "✓ Perte de poids",
      "✓ Prise de muscle",
      "✓ Tonification & posture",
      "✓ Préparation sportive"
    ],
    answerPointsEn: [
      "✓ Weight loss",
      "✓ Muscle gain",
      "✓ Toning & posture",
      "✓ Sports preparation"
    ]
  },
  {
    emoji: "👶",
    question: "Dois-je être sportif ?",
    questionEn: "Do I need to be athletic?",
    answerPoints: [
      "✓ NON ! Tous niveaux acceptés",
      "✓ Idéal pour débutants",
      "✓ Bons mouvements dès le départ",
      "✓ Zéro blessure"
    ],
    answerPointsEn: [
      "✓ NO! All levels welcome",
      "✓ Ideal for beginners",
      "✓ Right movements from start",
      "✓ Zero injuries"
    ]
  },
  {
    emoji: "🆓",
    question: "1ère consultation ?",
    questionEn: "First consultation?",
    answerPoints: [
      "✓ GRATUITE & sans engagement",
      "✓ Entretien + évaluation",
      "✓ Visite du studio",
      "✓ Plan d'action personnalisé"
    ],
    answerPointsEn: [
      "✓ FREE & no commitment",
      "✓ Interview + assessment",
      "✓ Studio tour",
      "✓ Personalized action plan"
    ]
  },
  {
    emoji: "🔒",
    question: "Séances vraiment privées ?",
    questionEn: "Truly private sessions?",
    answerPoints: [
      "✓ 100% privé",
      "✓ Seul(e) avec votre coach",
      "✓ 150m² rien que pour vous",
      "✓ Confidentialité totale"
    ],
    answerPointsEn: [
      "✓ 100% private",
      "✓ Alone with your coach",
      "✓ 150m² just for you",
      "✓ Total confidentiality"
    ]
  },
  {
    emoji: "⚡",
    question: "C'est quoi l'EMS Drysuit ?",
    questionEn: "What is EMS Drysuit?",
    answerPoints: [
      "✓ 20 min = stimulation intense du corps entier",
      "✓ Combinaison seche sans fil",
      "✓ Installation en 30 secondes",
      "✓ Electrodes aux epaules, bras, abdos..."
    ],
    answerPointsEn: [
      "✓ 20 min = intense full-body stimulation",
      "✓ Dry wireless suit",
      "✓ 30-second setup",
      "✓ Electrodes at shoulders, arms, abs..."
    ]
  },
  {
    emoji: "📍",
    question: "Localisation ?",
    questionEn: "Location?",
    answerPoints: [
      "✓ Route des Tattes d'Oie 95, Nyon",
      "✓ Parkings GRATUITS",
      "✓ Accès facile La Côte",
      "✓ Gland, Rolle, Coppet..."
    ],
    answerPointsEn: [
      "✓ Route des Tattes d'Oie 95, Nyon",
      "✓ FREE parking",
      "✓ Easy access La Côte",
      "✓ Gland, Rolle, Coppet..."
    ]
  },
  {
    emoji: "💳",
    question: "Paiements acceptés ?",
    questionEn: "Payment methods?",
    answerPoints: [
      "✓ Twint",
      "✓ Virement / Espèces",
      "✓ Paiement échelonné possible",
      "✓ Facture mensuelle"
    ],
    answerPointsEn: [
      "✓ Twint",
      "✓ Bank transfer / Cash",
      "✓ Installments available",
      "✓ Monthly invoice"
    ]
  }
];
